import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetEnfoqueDiferencial } from '../../shared/interfaces/database/evento';

@Injectable({
  providedIn: 'root'
})
export class EnfoqueDiferencialService {
  private readonly baseUrl = `${environment.apiUrl}/api/enfoque-diferencial`;

  constructor(private http: HttpClient) { }

  getEnfoqueDiferencial(): Observable<IGetEnfoqueDiferencial[]> {
    return this.http.get<IGetEnfoqueDiferencial[]>(`${this.baseUrl}`);
  }
}
